import { render, staticRenderFns } from "./SugestaoManage.vue?vue&type=template&id=03b8a1d6&scoped=true"
import script from "./SugestaoManage.vue?vue&type=script&lang=js"
export * from "./SugestaoManage.vue?vue&type=script&lang=js"
import style0 from "./SugestaoManage.vue?vue&type=style&index=0&id=03b8a1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8a1d6",
  null
  
)

export default component.exports